import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getOpenTreatmentOverview,
  type OpenTreatmentOverviewResult,
} from '@services/api/dashboard/treatment.api'

export function useOpenTreatmentOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<OpenTreatmentOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getOpenTreatmentOverview, {
    enabled,
    queued,
  })
}
